/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_Interrupted_ErrorInputs */

const en_read_along_ai_interrupted_error = /** @type {(inputs: Read_Along_Ai_Interrupted_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generation was interrupted. Try again.`)
};

const es_read_along_ai_interrupted_error = /** @type {(inputs: Read_Along_Ai_Interrupted_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La generación se interrumpió. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Generation was interrupted. Try again." |
*
* @param {Read_Along_Ai_Interrupted_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_interrupted_error = /** @type {((inputs?: Read_Along_Ai_Interrupted_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_Interrupted_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_interrupted_error(inputs)
	return en_read_along_ai_interrupted_error(inputs)
});